import type { TrackedTranslation } from '@ps/web-core-intl';
import { maxNumber, minNumber } from '@ps/web-shared-validators';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';

import NetLossInput from './NetLossInput/NetLossInput';
import {
  TXTCLI_The_maximum_value_for_this_lim_ELL,
  TXTWCL_The_minimum_value_for_this_lim_ELL
} from './NetLossLimitField.messages.json';

const minValue = 0.01;
const maxValue = 20000000;

const getValidationMessage = (message: TrackedTranslation, limitValue: number) => ({
  ...message,
  values: { 0: <CurrencyAmount value={limitValue * 100} /> }
});

const NetLossLimitField = () => (
  <NetLossInput
    validators={[
      minNumber(
        minValue,
        getValidationMessage(TXTWCL_The_minimum_value_for_this_lim_ELL, minValue),
        false,
        true
      ),
      maxNumber(
        maxValue,
        getValidationMessage(TXTCLI_The_maximum_value_for_this_lim_ELL, maxValue),
        true,
        true
      )
    ]}
  />
);

export default NetLossLimitField;
